<main class="set-password-page">
  <mat-card appearance="outlined" class="set-password-card">
    <mat-card-content>
      <h2>Set your password</h2>
      <p class="card-description">
        You signed in with Microsoft. Set a password to also sign in with your email next time.
      </p>

      <form (ngSubmit)="submit(passwordInput.value, confirmInput.value)" novalidate>
        <mat-form-field appearance="outline">
          <mat-label>New password</mat-label>
          <input matInput type="password" name="password" #passwordInput autocomplete="new-password" required />
          <mat-icon matSuffix aria-hidden="true">lock</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Confirm password</mat-label>
          <input matInput type="password" name="confirm" #confirmInput autocomplete="new-password" required />
          <mat-icon matSuffix aria-hidden="true">lock_reset</mat-icon>
        </mat-form-field>

        @if (errorMessage) {
          <p class="error-message" role="alert">{{ errorMessage }}</p>
        }

        <button mat-flat-button color="primary" class="submit-button" type="submit">
          <span>Save password</span>
          <mat-icon aria-hidden="true">check</mat-icon>
        </button>
      </form>
    </mat-card-content>
  </mat-card>
</main>
